
namespace Matrix
{
    export interface ColorPickerOptions {

    }

    @Serenity.Decorators.registerEditor([Serenity.IStringValue, Serenity.IReadOnly])
    @Serenity.Decorators.element('<input type="text" />')
    export class ColorPicker extends Serenity.Widget<ColorPickerOptions> implements Serenity.IStringValue, Serenity.IReadOnly {

        constructor(input: JQuery) {
            super(input);

            input.spectrum({
                allowEmpty: true,
                showInput: true,
                showPalette: true,
                palette: [
                    ["Black", "DimGray", "Gray", "DarkGray", "Silver", "LightGray", "Gainsboro", "White"],
                    ["Red", "Orange", "Yellow", "Green", "Aqua", "Blue", "Purple", "Magenta"],
                    ["MistyRose", "AntiqueWhite", "LightYellow", "HoneyDew", "LightCyan", "AliceBlue", "GhostWhite", "LavenderBlush"],
                    ["Salmon", "DarkSalmon", "Moccasin", "PaleGreen", "PaleTurquoise", "LightSkyBlue", "Violet", "Pink"],
                    ["IndianRed", "Coral", "PaleGoldenRod", "GreenYellow", "PowderBlue", "DeepSkyBlue", "Orchid", "PaleVioletRed"],
                    ["Crimson", "DarkOrange", "Khaki", "MediumSpringGreen", "Turquoise", "RoyalBlue", "MediumOrchid", "HotPink"],
                    ["FireBrick", "Tomato", "Gold", "ForestGreen", "LightSeaGreen", "MediumBlue", "DarkOrchid", "DeepPink"],
                    ["DarkRed", "OrangeRed", "DarkKhaki", "DarkGreen", "DarkCyan", "DarkBlue", "DarkMagenta", "MediumVioletRed"]
                ]
            });

            var replacer = input.next('.sp-replacer').addClass('editor').css({
                'display': 'flex',
                'flex-direction': 'row'
            });
            replacer.children('.sp-preview').css('flex', '1 1 50%')
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            this._readOnly = !!value;
            this.element.spectrum(!value ? 'enable' : 'disable');
        }

        get_value() {
            var t = this.element.spectrum('get');
            if (t == null)
                return null;

            var name = t.toName();
            if (name) 
                return colorToProperCase[name.toLowerCase()] || name;

            return t.toHexString();
        }

        set_value(value: string): void {
            if (!value)
                this.element.spectrum('set', null);
            else {
                this.element.spectrum('set', value);
            }
        }

    }

    var htmlColors = [



        'IndianRed ',
        'LightCoral',
        'Salmon',
        'DarkSalmon',
        'LightSalmon',
        'Crimson',
        'AliceBlue',
        'AntiqueWhite',
        'Aqua',
        'Aquamarine',
        'Azure',
        'Beige',
        'Bisque',
        'Black',
        'BlanchedAlmond',
        'Blue',
        'BlueViolet',
        'Brown',
        'BurlyWood',
        'CadetBlue',
        'Chartreuse',
        'Chocolate',
        'Coral',
        'CornflowerBlue',
        'Cornsilk',
        'Cyan',
        'DarkBlue',
        'DarkCyan',
        'DarkGoldenRod',
        'DarkGray',
        'DarkGrey',
        'DarkGreen',
        'DarkKhaki',
        'DarkMagenta',
        'DarkOliveGreen',
        'DarkOrange',
        'DarkOrchid',
        'DarkRed',
        'DarkSeaGreen',
        'DarkSlateBlue',
        'DarkSlateGray',
        'DarkSlateGrey',
        'DarkTurquoise',
        'DarkViolet',
        'DeepPink',
        'DeepSkyBlue',
        'DimGray',
        'DimGrey',
        'DodgerBlue',
        'FireBrick',
        'FloralWhite',
        'ForestGreen',
        'Fuchsia',
        'Gainsboro',
        'GhostWhite',
        'Gold',
        'GoldenRod',
        'Gray',
        'Grey',
        'Green',
        'GreenYellow',
        'HoneyDew',
        'HotPink',
        'Indigo ',
        'Ivory',
        'Khaki',
        'Lavender',
        'LavenderBlush',
        'LawnGreen',
        'LemonChiffon',
        'LightBlue',
        'LightCyan',
        'LightGoldenRodYellow',
        'LightGray',
        'LightGrey',
        'LightGreen',
        'LightPink',
        'LightSeaGreen',
        'LightSkyBlue',
        'LightSlateGray',
        'LightSlateGrey',
        'LightSteelBlue',
        'LightYellow',
        'Lime',
        'LimeGreen',
        'Linen',
        'Magenta',
        'Maroon',
        'MediumAquaMarine',
        'MediumBlue',
        'MediumOrchid',
        'MediumPurple',
        'MediumSeaGreen',
        'MediumSlateBlue',
        'MediumSpringGreen',
        'MediumTurquoise',
        'MediumVioletRed',
        'MidnightBlue',
        'MintCream',
        'MistyRose',
        'Moccasin',
        'NavajoWhite',
        'Navy',
        'OldLace',
        'Olive',
        'OliveDrab',
        'Orange',
        'OrangeRed',
        'Orchid',
        'PaleGoldenRod',
        'PaleGreen',
        'PaleTurquoise',
        'PaleVioletRed',
        'PapayaWhip',
        'PeachPuff',
        'Peru',
        'Pink',
        'Plum',
        'PowderBlue',
        'Purple',
        'RebeccaPurple',
        'Red',
        'RosyBrown',
        'RoyalBlue',
        'SaddleBrown',
        'SandyBrown',
        'SeaGreen',
        'SeaShell',
        'Sienna',
        'Silver',
        'SkyBlue',
        'SlateBlue',
        'SlateGray',
        'SlateGrey',
        'Snow',
        'SpringGreen',
        'SteelBlue',
        'Tan',
        'Teal',
        'Thistle',
        'Tomato',
        'Turquoise',
        'Violet',
        'Wheat',
        'White',
        'WhiteSmoke',
        'Yellow',
        'YellowGreen'
    ]

    var colorToProperCase = {};
    for (var x of htmlColors)
        colorToProperCase[x.toLowerCase()] = x;

}
